<div class="container-fluid" style="min-height: 110vh;" *ngIf="user">
    <app-product-search [params]="productParams" [showSupplier]="false"></app-product-search>

</div>
